<template>
    <div class="container admin-menu-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{labels.title}}</h2>
        </div>
        <b-row v-if="!isLoading">
            <div class="admin-table-block mt-4" v-if="listMenus?.length">
                <CorporateDataTable
                    :items="listMenus"
                    :fields="allFields"
                    :filter-defs="tableFilterDefs"
                    :labels="tableLabels"
                    :default-per-page="10"
                    :page-options="[10, 20, 50, 100]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                >
                    <template #toolbar-actions>
                        <b-button
                            size="sm"
                            class="table-toolbar-secondary-btn mr-2"
                            @click="abrirCatalogoIconos()"
                            :title="labels.iconCatalog"
                        >
                            <i class="fa-solid fa-icons mr-1"></i>{{ labels.iconCatalogShort }}
                        </b-button>
                        <b-button size="sm" class="table-toolbar-add-btn" @click="crearMenu()">
                            {{ labels.add }}
                        </b-button>
                    </template>
                    <template #cell(accionEdit)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px;"
                            class="md-fab md-primary table-action-btn"
                            @click="editMenu(data.item.id)"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
                        </b-button>
                    </template>
                    <template #cell(accionAsoc)="data">
                        <b-button
                            style="background-color: #2e5072; width: 30px; height: 30px;"
                            class="md-fab md-primary table-action-btn"
                            @click="listarRoles(data.item.id)"
                        >
                            <i><font-awesome-icon :icon="['fas', 'cubes']" size="xs"/></i>
                        </b-button>
                    </template>
                </CorporateDataTable>
            </div>
            <div class="admin-table-block mt-4" v-else>
                <h5>{{ labels.noRow }}</h5>
            </div>
        </b-row>
        <Crear :modCrearMenu="modCrearMenu" @closeModal="closeModal"/>
        <Editar :modEditarMenu="modEditarMenu" :infoMenu="datosMenu" @closeModal="closeModal"></Editar>
        <AsociaDesasociaRol :modAsociaDesasociaRol="modalRoles" :infoMenu="datosMenu" @closeModal="closeModal"/>
        <CatalogoIconos :modCatalogoIconos="modalCatalogoIconos" @closeModal="closeModal"/>
    </div>
</template>
<script>
import Menu from '../../../services/Menu'; 
import CorporateDataTable from '../../utils/CorporateDataTable.vue';
import Crear from './Crear.vue'; 
import Editar from './EditarMenu.vue'; 
import AsociaDesasociaRol from './AsociaDesasociaRol.vue'; 
import CatalogoIconos from './CatalogoIconos.vue';

export default {
    name:'AdministradorMenu',
    components:{
        Crear,
        Editar,
        AsociaDesasociaRol,
        CatalogoIconos,
        CorporateDataTable
    },
    data: () => ({
        isLoading: false,
        listMenus : [],
        modCrearMenu: false,
        modEditarMenu: false,
        modalRoles: false,
        modalCatalogoIconos: false,
        datosMenu: [],
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title : "Menús",
                    nombre : "Nombre",
                    ruta : "Url",
                    icono : "Icono",
                    edit : "Editar",
                    rol : "Roles",
                    orden : "Orden",
                    iconCatalog: "Catálogo de iconos",
                    iconCatalogShort: "Iconos",
                    add: "Añadir menú",
                    noRow: "No hay registros",
                    noMatches: "No se encontraron resultados",
                    searchPlaceholder: "Buscar en la tabla...",
                    rowsPerPage: "Filas por página:",
                    noSort: "Sin orden",
                    sortAsc: "A-Z / Menor a mayor",
                    sortDesc: "Z-A / Mayor a menor",
                    columns: "Columnas",
                    showAllColumns: "Mostrar todas",
                    filters: "Filtros",
                    clearFilters: "Limpiar filtros",
                    filterName: "Filtrar nombre...",
                    filterRoute: "Filtrar url..."
                }
            }else{
                return {
                    title : "Menu",
                    nombre : "Name",
                    ruta : "Url",
                    icono : "Icon",
                    edit : "Edit",
                    rol : "Role",
                    orden : "Order",
                    iconCatalog: "Icon catalog",
                    iconCatalogShort: "Icons",
                    add: "Add menu",
                    noRow: "There are not records",
                    noMatches: "No results found",
                    searchPlaceholder: "Search in table...",
                    rowsPerPage: "Rows per page:",
                    noSort: "No sorting",
                    sortAsc: "A-Z / Low to high",
                    sortDesc: "Z-A / High to low",
                    columns: "Columns",
                    showAllColumns: "Show all",
                    filters: "Filters",
                    clearFilters: "Clear filters",
                    filterName: "Filter name...",
                    filterRoute: "Filter url..."
                }
            }
        },
        allFields(){
            return [
                { key: 'nombre', label: this.labels.nombre, sortable: true },
                { key: 'ruta', label: this.labels.ruta, sortable: true },
                { key: 'icono', label: this.labels.icono, sortable: true },
                { key: 'orden', label: this.labels.orden, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'accionAsoc', label: this.$store.state._language == "es-ES" ? 'Asociar menú' : 'Associate menu', thClass: 'text-center', tdClass: 'text-center', sortable: false },
                { key: 'accionEdit', label: this.labels.edit, thClass: 'text-center', tdClass: 'text-center', sortable: false }
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'nombre', type: 'text', placeholder: this.labels.filterName },
                { key: 'ruta', type: 'text', placeholder: this.labels.filterRoute }
            ]
        },
        tableLabels(){
            return {
                noRow: this.labels.noRow,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        }
    },
    mounted(){
        Menu.getAllMenu() 
        .then((res) => { 
            // console.log(res.data) 
            this.listMenus = res.data.listMenu 
        })
        .catch((err) => { 
            console.log(err) 
        })
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        closeModal(val){
            this.modCrearMenu = val 
            this.modEditarMenu = val 
            this.modalRoles = val 
            this.modalCatalogoIconos = val
        },
        crearMenu(){
            this.modCrearMenu = true 
        },
        abrirCatalogoIconos(){
            this.modalCatalogoIconos = true
        },
        editMenu(idMenu){
            // console.log(idMenu) 
            Menu.getMenuById(idMenu) 
            .then((res) => { 
                // console.log(res.data.menu) 
                this.datosMenu = res.data.menu 
            })
            .catch((err) => { 
                console.log(err) 
            })
            .finally(() => { 
                this.modEditarMenu = true 
            })
        },
        listarRoles(idMenu){
            // console.log("LISTAR: ",idMenu) 
            Menu.getMenuById(idMenu) 
            .then((res) => { 
                // console.log(res.data.menu) 
                this.datosMenu = res.data.menu 
            })
            .catch((err) => { 
                console.log(err) 
            })
            .finally(() => { 
                this.modalRoles = true 
            })
        }
    }
}
</script>

<style>

</style>
